import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeviceMountWall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14 1L14 19H11L11 16H9C7.34315 16 6 14.6569 6 13L6 7C6 5.34315 7.34315 4 9 4H11V1L14 1ZM12 7V13H13V7H12ZM12 14L12 18H13L13 14H12ZM11 5H9C7.89543 5 7 5.89543 7 7L7 13C7 14.1046 7.89543 15 9 15H11L11 5ZM13 2V6H12V2H13Z",
		fill: "currentColor"
	})
});
export default SvgDeviceMountWall;
